import { createSlice } from "@reduxjs/toolkit";

const breadcrumbsSlice = createSlice({
	name: "breadcrumbs",
	initialState: { path: [] },
	reducers: {
		setBreadcrumbs(state, action) {
			state = {path: action.payload};
            return state;
		},
	},
});

export const breadcrumbsActions = breadcrumbsSlice.actions;
export default breadcrumbsSlice.reducer;
